import { get, filter } from 'lodash';

import {
  SEGMENT_OPEN,
  SEGMENT_CLOSE,
  SEGMENT_SAVE_REQUEST,
  SEGMENT_SAVE_SUCCESS,
  SEGMENT_SAVE_ERROR
} from '../actions/audience-segment-actions';

const initialState = {
  uuid: null,
  name: '',
  filters: '',
  open: false,
  loading: false,
  error: false
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SEGMENT_OPEN: {
      return {
        ...state,
        open: true,
        uuid: action.uuid,
        name: action.name,
        filters: action.filters
      };
    }

    case SEGMENT_CLOSE: {
      return initialState;
    }

    case SEGMENT_SAVE_REQUEST: {
      return { ...state, loading: true };
    }

    case SEGMENT_SAVE_SUCCESS: {
      return { ...state, loading: false };
    }

    case SEGMENT_SAVE_ERROR: {
      return { ...state, loading: false, error: action.error };
    }

    default:
      return state;
  }
}

export const selectId = state => get(state, ['audienceSegment', 'id'], null);
export const selectName = state => get(state, ['audienceSegment', 'name'], '');
export const selectFilters = state => {
  const filts = get(state, ['audienceSegment', 'filters'], []);

  if (filts) {
    return filter(filts, f => {
      if (Array.isArray(f.value)) {
        return true;
      }

      return !f.value || !f.value.label;
    });
  }
  return filts;
};

export const selectOpen = state =>
  get(state, ['audienceSegment', 'open'], false);
export const selectLoading = state =>
  get(state, ['audienceSegment', 'loading'], false);
export const selectError = state =>
  get(state, ['audienceSegment', 'error'], false);
